import type { ElementType, ReactNode } from "react";

/**
 * Sanftes Einblenden beim Scrollen – OHNE JavaScript.
 *
 * Vorher war das ein Client-Component mit IntersectionObserver. Auf der
 * Startseite steckte es rund 50-mal drin: 50 Beobachter, 50-mal Hydration,
 * und JavaScript im Auslieferungspfad nur für einen optischen Effekt.
 *
 * Jetzt übernimmt das die CSS-Eigenschaft `animation-timeline: view()`.
 * Browser, die sie beherrschen, blenden beim Scrollen ein; alle anderen
 * zeigen den Inhalt schlicht sofort an. Das ist der bessere Ausfallmodus:
 * Inhalt ist nie unsichtbar, nur weil Technik fehlt oder JavaScript hakt.
 *
 * `immediate` behält seine Bedeutung: kein Effekt, sofort sichtbar – für
 * alles im ersten Bildschirm, damit der Largest Contentful Paint nicht
 * auf eine Animation wartet.
 */
export function Reveal({
  children,
  as: Tag = "div",
  delay = 0,
  className = "",
  immediate = false,
}: {
  children: ReactNode;
  as?: ElementType;
  delay?: number;
  className?: string;
  /** Sofort sichtbar, ohne Effekt – für Inhalte im ersten Bildschirm (LCP). */
  immediate?: boolean;
}) {
  if (immediate) {
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <Tag
      className={`reveal ${className}`}
      style={delay ? ({ "--reveal-delay": `${delay}ms` } as React.CSSProperties) : undefined}
    >
      {children}
    </Tag>
  );
}
